import "./BookAppointment.module.css";
import Header from "@/reusable_sections/Header";
import AppointmentForm from "./sections/AppointmentForm";
import Footer from "@/reusable_sections/Footer";
export default function BookAppointmentPage() {
  return <div>
      <Header />
      <AppointmentForm />
      <Footer />
    </div>;
}